export default __webpack_public_path__ + "static/media/termlife_file_download_icon_customer.5bc53784.svg";